import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/external_link.svg';
const ExternalLink = () => React.createElement(IconSvg, null);
export default ExternalLink;
